import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-b37dc7a8")

_pushScopeId("data-v-b37dc7a8")
const _hoisted_1 = { class: "ion-text-center" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Spara ")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_ion_select_option = _resolveComponent("ion-select-option")
  const _component_ion_select = _resolveComponent("ion-select")
  const _component_ion_col = _resolveComponent("ion-col")
  const _component_ion_row = _resolveComponent("ion-row")
  const _component_ion_grid = _resolveComponent("ion-grid")
  const _component_ion_text = _resolveComponent("ion-text")
  const _component_GameItem = _resolveComponent("GameItem")
  const _component_ion_button = _resolveComponent("ion-button")
  const _component_base_layout = _resolveComponent("base-layout")

  return (_openBlock(), _createBlock(_component_base_layout, {
    "page-title": "Skapa match",
    "page-default-back-link": _ctx.group ? `/group/${_ctx.group.id}` : 'home'
  }, {
    default: _withId(() => [
      _createVNode("form", {
        onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onSumbit && _ctx.onSumbit(...args)), ["prevent"]))
      }, [
        _createVNode(_component_ion_grid, null, {
          default: _withId(() => [
            _createVNode(_component_ion_row, null, {
              default: _withId(() => [
                _createVNode(_component_ion_col, null, {
                  default: _withId(() => [
                    _createVNode(_component_ion_select, {
                      interface: "popover",
                      onIonChange: _ctx.matchSelected,
                      modelValue: _ctx.matchId,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.matchId = $event))
                    }, {
                      default: _withId(() => [
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.matchOptions, (option) => {
                          return (_openBlock(), _createBlock(_component_ion_select_option, {
                            key: option.label,
                            value: option.value
                          }, {
                            default: _withId(() => [
                              _createTextVNode(_toDisplayString(option.label), 1)
                            ]),
                            _: 2
                          }, 1032, ["value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["onIonChange", "modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_ion_text, {
          color: _ctx.matchSetupValid ? 'success' : 'danger'
        }, {
          default: _withId(() => [
            _createVNode("h3", _hoisted_1, _toDisplayString(_ctx.msg), 1)
          ]),
          _: 1
        }, 8, ["color"]),
        (_ctx.matchSetupValid)
          ? (_openBlock(), _createBlock("div", _hoisted_2, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.games, (game) => {
                return (_openBlock(), _createBlock(_component_GameItem, {
                  key: game.name,
                  gameData: game
                }, null, 8, ["gameData"]))
              }), 128)),
              _createVNode(_component_ion_button, {
                type: "submit",
                expand: "full",
                disabled: _ctx.btnDisabled
              }, {
                default: _withId(() => [
                  _hoisted_3
                ]),
                _: 1
              }, 8, ["disabled"])
            ]))
          : _createCommentVNode("", true)
      ], 32)
    ]),
    _: 1
  }, 8, ["page-default-back-link"]))
})